import axiosInstance from "../api/api";

const CompanyService = {
    list: function () {
        return axiosInstance({
            url: "/api/company/",
            method: "GET",
        });
    },
    fetch: function (uniqueId) {
        return axiosInstance({
            url: `/api/company/${uniqueId}`,
            method: "GET",
        });
    },
    delete: function (uniqueId) {
        return axiosInstance({
            url: `/api/company/${uniqueId}`,
            method: "DELETE",
        });
    },
    create: function (formData) {
        return axiosInstance({
            url: `/api/company/`,
            method: "POST",
            data: formData,
        });
    },
    update: function (formData) {
        return axiosInstance({
            url: `/api/company/`,
            method: "PATCH",
            data: formData,
        });
    },
};
export default CompanyService;
